import { datadogRum } from '@datadog/browser-rum';

let hasInitializedRum = false;

export const setupDataDogRum = (environment: string, version?: string) => {
  if (!hasInitializedRum) {
    datadogRum.init({
      applicationId: 'ca4bbe0c-66eb-4751-bb81-38dcd865358b',
      clientToken: 'pub09a57f4c4fd7ee6f771e029f76de5125',
      site: 'datadoghq.com',
      service: 'wpt-static-pages',
      env: environment,
      version: version || '1.0.0',
      sessionSampleRate: 20,
      sessionReplaySampleRate: 20,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
    });
    datadogRum.startSessionReplayRecording();
    hasInitializedRum = true;
  }

  return datadogRum;
};
